import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styles from './TitleCell.module.css';

const POSTER_CDN = 'https://cdn-fastly.parrotanalytics.com/images/poster-hyphen';

export interface TitleCellProps {
  parrotId: string;
  title: string;
  /** Muted second line, e.g. "2019 • Comedy". */
  meta?: ReactNode;
  /** A small tag after the meta, e.g. "Licensed". */
  tag?: string;
}

/**
 * The leading cell of a title table: poster, name and a muted facts line,
 * linking to the title profile. Shared by every title leaderboard.
 */
export function TitleCell({ parrotId, title, meta, tag }: TitleCellProps) {
  return (
    <Link to={`/titles/${parrotId}`} className={styles.link}>
      <img
        src={`${POSTER_CDN}/${parrotId}.jpg?width=80`}
        alt=""
        className={styles.poster}
        loading="lazy"
        onError={(e) => e.currentTarget.classList.add(styles.posterMissing)}
      />
      <span className={styles.info}>
        <span className={styles.name}>{title}</span>
        {(meta || tag) && (
          <span className={styles.meta}>
            {meta}
            {tag && <span className={styles.tag}>{tag}</span>}
          </span>
        )}
      </span>
    </Link>
  );
}
